<template>
  <div v-if="visible" class="modal">
    <div class="modal-content">
      <span class="close-grafico" @click="close">&times;</span>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isSingleChart: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
/* Contenedor principal del modal */
.modal {
  display: flex; /* Flexbox para centrar contenido */
  align-items: center; /* Centrado vertical */
  justify-content: center; /* Centrado horizontal */
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4); /* Fondo semitransparente */
  z-index: 1050; /* Mayor prioridad para el modal */
}

/* Contenido del modal */
.modal-content {
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  width: 70%;
  overflow-y: auto; /* Scroll interno si es necesario */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  /*Centrar contenido */
  display: flex;
  flex-direction: columns;
  align-items: center;
  padding: 20px;
}

/* Botón de cerrar */
.close-grafico {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 36px;
  cursor: pointer;
}
</style>